import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import './Table.scss';

import commonConstant from '../../common/_commonConstant';
import { randomNumber } from '../../common/_commonFunction';
import { Dropdown, isNewCreatedUser } from '../../helpers';

const itemPageSize = [
  { 'label': '10', 'value': 10 },
  { 'label': '15', 'value': 15 },
  { 'label': '20', 'value': 20 },
  { 'label': '25', 'value': 25 },
  { 'label': '30', 'value': 30 },
];

export default class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.dropdown = createRef();
  }
  handleSort = ele => {
    const { handleSort, sort } = this.props;

    if (ele.sort) {
      if (ele.key === sort.key) {
        return handleSort({ 'key': ele.key, 'sort': !sort.sort });
      }
      return handleSort({ 'key': ele.key, 'sort': false });
    }
    return null;
  }

  handleItemHeader = () => {
    const { columnHeader, sort } = this.props;

    if (!columnHeader) {
      return null;
    }

    return columnHeader.map(ele => (
      <th
        id={`table-header-${ele.className}`}
        className={`box-header${ele.sort ? ' sort' : ''}`}
        key={randomNumber()}
        onClick={() => this.handleSort(ele)}
      >
        <div className={`item-header${ele.className ? ` ${ele.className}` : ''}${ele.key === sort.key ? ' active' : ''}`}>
          <span className="label">{ele.label}</span>
          {/* // NOTE: ascending === false, descending === true */}
          {
            ele.sort ?
              <span className="box-icon">
                <span className={`icon fas fa-caret-up${ele.key === sort.key && sort.sort ? ' active' : ''}`} />
                <span className={`icon fas fa-caret-down${ele.key === sort.key && !sort.sort ? ' active' : ''}`} />
              </span>
              : null
          }
        </div>
      </th>
    ));
  }

  handleTRBody = (ele, rowNumber, condition) => {
    try {
      const { columnHeader, passFuncBody, objToPassFuncBody, passFuncClick, fadeDeletedField, highlightNewCreatedField, pageSize, pageNumber } = this.props;

      return columnHeader.map((item, index) => (
        <td className={`box-body${item.className ? ` ${item.className}` : ''}${condition ? ' no-border' : ''}`} key={randomNumber()}>
          {highlightNewCreatedField ? isNewCreatedUser(ele.createdAt) ? <span className="highlight animated fadeOut delay-5s" /> : null : null}
          <div className={`item-body${fadeDeletedField ? ele.deletedAt ? ' deleted' : '' : ''}`}>
            <span
              id={`table-col-${item.className}-${rowNumber}`}
              className={`text${passFuncClick && passFuncClick[item.keyFuncName] ? ' pointer' : ''}${item.icon ? ` ${item.iconClassName}` : ''}`}
              onClick={passFuncClick && passFuncClick[item.keyFuncName] ? () => passFuncClick[item.keyFuncName](ele) : null}
            >
              {passFuncBody[index] ? passFuncBody[index](ele, objToPassFuncBody, pageSize.value, pageNumber, rowNumber, condition) : ele[item]}
            </span>
          </div>
        </td>
      ));
    } catch (error) {
      return null;
    }
  }

  handleItemBody = () => {
    const { data, columnHeader, groupItemsCondition } = this.props;

    if (!data || !columnHeader) {
      return null;
    }

    let countRow = 0;
    return data.map((ele, rowNumber) => {
      const condition = rowNumber > 0 && groupItemsCondition ? groupItemsCondition(ele, data[rowNumber - 1]) : false;

      if (!condition && rowNumber !== 0) {
        countRow += 1;
      }

      return (
        <tr key={randomNumber()} id={`table-row-${rowNumber}`}>
          {this.handleTRBody(ele, countRow, condition)}
        </tr>
      );
    });
  }

  handlePage = () => {
    const { maxData, pageSize, pageNumber, handlePageChange } = this.props;

    if (pageNumber === 1) {
      return (
        <span className="box-page">
          <span className="page active" id="table-pagination-1">1</span>
          {Math.ceil(maxData / pageSize.value) >= (pageNumber + 1) ? <span className="page" id={`table-pagination-${pageNumber + 1}`} onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span> : null}
          {Math.ceil(maxData / pageSize.value) >= (pageNumber + 2) ? <span className="page" id={`table-pagination-${pageNumber + 2}`} onClick={() => handlePageChange(pageNumber + 2)}>{pageNumber + 2}</span> : null}
        </span>
      );
    } else if (pageNumber === Math.ceil(maxData / pageSize.value)) {
      return (
        <span className="box-page">
          {(pageNumber - 2) > 0 ? <span className="page" id={`table-pagination-${pageNumber - 2}`} onClick={() => handlePageChange(pageNumber - 2)}>{pageNumber - 2}</span> : null}
          {(pageNumber - 1) > 0 ? <span className="page" id={`table-pagination-${pageNumber - 1}`} onClick={() => handlePageChange(pageNumber - 1)}>{pageNumber - 1}</span> : null}
          {Math.ceil(maxData / pageSize.value) >= pageNumber ? <span className="page active" id={`table-pagination-${pageNumber}`}>{pageNumber}</span> : null}
        </span>
      );
    } else if (pageNumber - 1 <= Math.ceil(maxData / pageSize.value)) {
      return (
        <span className="box-page">
          {(pageNumber - 1) > 0 ? <span className="page" id={`table-pagination-${pageNumber - 1}`} onClick={() => handlePageChange(pageNumber - 1)}>{pageNumber - 1}</span> : null}
          {Math.ceil(maxData / pageSize.value) >= pageNumber ? <span className="page active" id={`table-pagination-${pageNumber}`}>{pageNumber}</span> : null}
          {Math.ceil(maxData / pageSize.value) >= (pageNumber + 1) ? <span className="page" id={`table-pagination-${pageNumber + 1}`} onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span> : null}
        </span>
      );
    }
  }

  handleEmptyBody = () => {
    const { data } = this.props;

    try {
      if (data.length > 0) {
        return null;
      }

      return (
        <div className="box-not-found">
          <div className="result">ผลการค้นหา</div>
          <div className="result">{this.handleFilter()}</div>
          <img className="not-found" src={commonConstant.notFoundImg} alt="" />
          <div className="text-not-found">ไม่พบข้อมูล</div>
        </div>
      );
    } catch (error) {
      return null;
    }
  }

  handleFilter = () => {
    const { filter } = this.props;

    if (!filter) {
      return null;
    }

    let str = '';
    filter.map(ele => str += `${str !== '' ? ' ' : ''}"${ele.label}"`);
    return str;
  }

  handleItems = () => itemPageSize.map((ele, index) => (
    <div
      id={`table-pagination-${index}`}
      className={`item${this.props.pageSize.value && ele.value === this.props.pageSize.value ? ' active' : ''}`}
      key={randomNumber()}
      onClick={() => this.handlePageSize(ele)}
    >
      <span>{ele.label}</span>
    </div>
  ));

  handlePageSize = value => {
    this.dropdown.current.handleShowItem();
    return this.props.handlePageSize(value);
  }

  render() {
    const { pageSize, pageNumber, maxData, handlePageChange, columnHeader, id } = this.props;

    if (!columnHeader || !pageSize || !pageNumber || maxData === undefined) {
      return null;
    }

    return (
      <div className="Table">
        <div className="box-table">
          <table id={id}>
            <thead>
              <tr>
                {this.handleItemHeader()}
              </tr>
            </thead>
            <tbody>
              {this.handleItemBody()}
            </tbody>
          </table>
          {this.handleEmptyBody()}
        </div>
        <div className="box-detail">
          <div className="detail-page">
            <span className="box-select-page-size">
              <span>View</span>
              <Dropdown
                id="table-pagination-size"
                placeholder="Size"
                item={itemPageSize}
                value={pageSize.value}
                ref={this.dropdown}
              >
                {this.handleItems()}
              </Dropdown>
              <span>items per page</span>
            </span>
            <span>
              <span id="table-current-page">{(pageSize.value * pageNumber) - (pageSize.value - 1) >= 1 ? (pageSize.value * pageNumber) - (pageSize.value - 1) : 1} - {pageSize.value * pageNumber <= maxData ? pageSize.value * pageNumber : maxData} </span>
              out of
              <span id="table-total-row"> {maxData} </span>
              items
            </span>
          </div>
          <div className="box-pagination">
            <span className="page" id="table-pagination-first-page" onClick={pageNumber !== 1 ? () => handlePageChange(1) : null}>
              &lt;&lt;
            </span>
            <span className="page" id="table-pagination-previous-page" onClick={pageNumber - 1 > 0 ? () => handlePageChange(pageNumber - 1) : null}>
              &lt;
            </span>
            {this.handlePage()}
            <span className="page" id="table-pagination-next-page" onClick={pageNumber + 1 <= Math.ceil(maxData / pageSize.value) ? () => handlePageChange(pageNumber + 1) : null}>
              &gt;
            </span>
            <span className="page" id="table-pagination-last-page" onClick={pageNumber < Math.ceil(maxData / pageSize.value) ? () => handlePageChange(Math.ceil(maxData / pageSize.value)) : null}>
              &gt;&gt;
            </span>
          </div>
        </div>
      </div>
    );
  }
}

Table.propTypes = {
  'columnHeader': PropTypes.array.isRequired,
  'data': PropTypes.array.isRequired,
  'passFuncBody': PropTypes.array,
  'maxData': PropTypes.number.isRequired,
  'pageSize': PropTypes.shape({
    'label': PropTypes.string.isRequired,
    'value': PropTypes.number.isRequired,
  }).isRequired,
  'pageNumber': PropTypes.number.isRequired,
  'handlePageChange': PropTypes.func.isRequired,
  'isSort': PropTypes.bool,
  'sort': PropTypes.shape({
    'key': PropTypes.string,
    'sort': PropTypes.bool,
  }),
  'handleSort': PropTypes.func,
  'handlePageSize': PropTypes.func.isRequired,
  'filter': PropTypes.array,
  'objToPassFuncBody': PropTypes.shape({}),
  'passFuncClick': PropTypes.shape({}),
  'fadeDeletedField': PropTypes.bool,
  'highlightNewCreatedField': PropTypes.bool,
  'id': PropTypes.string,
  'groupItemsCondition': PropTypes.func,
};
